import styled from 'styled-components';
import NextImage from 'next/image';

export const NextCarouselImgWrapper = styled.div`
  height: 348px;
  position: relative;
  width: 286px;
  margin-top: 12px;
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: 8px;
  padding: 7px 8px;
`;

export const ImageDiv = styled.div`
  height: 200px;
  position: relative;
  *,
  :after,
  :before {
    border-radius: 8px;
  }
`;
export const SeturLogoWrapper = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: auto !important;
  height: fit-content !important;
  z-index: 50;
`;

export const Image = styled(NextImage)<{ opacity?: number; cursor?: boolean }>`
  width: 100%;
  height: 243px;
  transition: all 0.35s;
  opacity: ${({ opacity }) => (opacity ? `${opacity}` : '1')};
  z-index: 40;
  cursor: ${({ cursor }) => (cursor ? `pointer` : 'unset')};
`;

export const NameBodyWrapper = styled.span`
  display: flex;
  height: 45px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
  margin-top: 2px;
`;

export const RegionWrapper = styled.div`
  height: 20px;
`;

export const ShowTourButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

export const ShowTourButton = styled.div`
  display: flex;
  padding: 11px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL0};
  border: 1px solid ${({ theme }) => theme.palette.persianRed};
  width: 71px;
  height: 40px;
  text-wrap: nowrap;
  cursor: pointer;
`;

export const CarouselWrapper = styled.div`
  padding-left: 10px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px;
  }
`;

export const MainWrapper = styled.div`
  .swiper-button-next,
  .swiper-button-prev {
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 50px;
    color: white;
    width: 50px;
    height: 50px;
    border: 2px solid ${({ theme }) => theme.palette.white};
    top: 125px !important;
    ::after {
      font-size: 32px;
    }
    :hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .swiper-button-disabled {
    opacity: 0.35;
    cursor: unset;
    pointer-events: unset !important;
  }
`;
